export const pharmacyConst = {
  path: "/single-programs/pharmacy",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ФАРМАЦИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Фармация — наука о лекарствах и здоровье</h2>
      <p>
        Фармация — это стратегически важная область медицины, объединяющая научный подход, клиническую практику и фармакологическое
        производство. Специальность направлена на подготовку профессионалов, способных разрабатывать, анализировать, контролировать качество
        и безопасно применять лекарственные средства.
      </p>
      <p>
        Программа охватывает широкий спектр дисциплин: от химии и биологии до фармакотерапии, фармацевтической технологии и клинической
        практики. Выпускники приобретают глубокие знания о действии лекарств, взаимодействии компонентов, стандартах GMP и роли фармацевта в
        системе здравоохранения.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Органическая и фармацевтическая химия</li>
        <li>Анатомия, физиология и биохимия человека</li>
        <li>Фармакология и фармакотерапия</li>
        <li>Технология изготовления лекарств</li>
        <li>Фармацевтический менеджмент и маркетинг</li>
        <li>Качество и сертификация препаратов</li>
        <li>Токсикология и безопасность медикаментов</li>
        <li>Клиническая фармация и взаимодействие с пациентами</li>
        <li>Основы фармаконадзора и регуляторные нормы ЕС</li>
      </ul>
      <p>
        Обучение сопровождается лабораторной практикой, симуляциями фармацевтических процессов, стажировками в аптеках, фармкомпаниях и
        научных институтах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Провизор в аптеках и медицинских учреждениях</li>
        <li>Специалист по разработке и тестированию лекарств</li>
        <li>Регуляторный эксперт или сотрудник фармацевтической инспекции</li>
        <li>Медицинский представитель международной фармкомпании</li>
        <li>Научный сотрудник в области биомедицины</li>
        <li>Преподаватель и консультант в фармацевтическом образовании</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>
        Фармация — одна из самых динамично развивающихся отраслей. Профессионалы в этой сфере особенно востребованы в Европе, странах СНГ и
        Азии.
      </p>
      <p>
        <strong>Средний доход провизора или клинического фармаколога в Европе — от €45,000 до €90,000 в год,</strong> с возможностью роста в
        международных компаниях.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Международный диплом, признанный в ЕС и странах СНГ</li>
        <li>Программа доступна на русском и английском языках</li>
        <li>Гибкий формат обучения — очный или дистанционный</li>
        <li>Партнёрство с международными фармацевтическими компаниями</li>
        <li>Современные лаборатории и симуляционные технологии</li>
        <li>Индивидуальная поддержка на всех этапах обучения и карьеры</li>
      </ul>
      <h2>Образование с прицелом на инновации и результат</h2>
      <p>
        Мы обучаем будущих фармацевтов, которые не просто отпускают лекарства, а формируют здоровье нации. Выпускники становятся частью
        международного фармацевтического сообщества, способного влиять на качество и доступность медицины по всему миру.
      </p>
      <h2>Как поступить?</h2>
      <p>
        Заполните форму, прикрепите необходимые документы и дождитесь консультации приёмной комиссии. Мы поможем вам сделать первый шаг к
        профессии будущего.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приёмной комиссии

    Фармация — наука о лекарствах и здоровье
    
    Фармация — это стратегически важная область медицины, объединяющая научный подход, клиническую практику и фармакологическое производство. Специальность направлена на подготовку профессионалов, способных разрабатывать, анализировать, контролировать качество и безопасно применять лекарственные средства.
    Программа охватывает широкий спектр дисциплин: от химии и биологии до фармакотерапии, фармацевтической технологии и клинической практики. Выпускники приобретают глубокие знания о действии лекарств, взаимодействии компонентов, стандартах GMP и роли фармацевта в системе здравоохранения.

    Что вы будете изучать?
    • Органическая и фармацевтическая химия
    • Анатомия, физиология и биохимия человека
    • Фармакология и фармакотерапия
    • Технология изготовления лекарств
    • Фармацевтический менеджмент и маркетинг
    • Качество и сертификация препаратов
    • Токсикология и безопасность медикаментов
    • Клиническая фармация и взаимодействие с пациентами
    • Основы фармаконадзора и регуляторные нормы ЕС
    Обучение сопровождается лабораторной практикой, симуляциями фармацевтических процессов, стажировками в аптеках, фармкомпаниях и научных институтах.

    Кем можно работать после окончания?
    • Провизор в аптеках и медицинских учреждениях
    • Специалист по разработке и тестированию лекарств
    • Регуляторный эксперт или сотрудник фармацевтической инспекции
    • Медицинский представитель международной фармкомпании
    • Научный сотрудник в области биомедицины
    • Преподаватель и консультант в фармацевтическом образовании

    Востребованность и доход
    Фармация — одна из самых динамично развивающихся отраслей. Профессионалы в этой сфере особенно востребованы в Европе, странах СНГ и Азии.
    Средний доход провизора или клинического фармаколога в Европе — от €45,000 до €90,000 в год, с возможностью роста в международных компаниях.

    Почему выбирают нас?
    • Международный диплом, признанный в ЕС и странах СНГ
    • Программа доступна на русском и английском языках
    • Гибкий формат обучения — очный или дистанционный
    • Партнёрство с международными фармацевтическими компаниями
    • Современные лаборатории и симуляционные технологии
    • Индивидуальная поддержка на всех этапах обучения и карьеры

    Образование с прицелом на инновации и результат
    Мы обучаем будущих фармацевтов, которые не просто отпускают лекарства, а формируют здоровье нации. Выпускники становятся частью международного фармацевтического сообщества, способного влиять на качество и доступность медицины по всему миру.
    Как поступить?
    Заполните форму, прикрепите необходимые документы и дождитесь консультации приёмной комиссии. Мы поможем вам сделать первый шаг к профессии будущего.
  `,
};
